// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Teaser as t } from '@xprog/prensa/types'

export const TeaserChargeLg: t.TeaserProps = {
  css: {
    flexDirection: 'column-reverse',
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      my: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '20px',
      fontWeight: 500,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      width: '100%'
    }
  },
  className: 'TeaserChargeLg',
  imageDerivative: 'default',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
}